export default {
  cart: null,
  cartLoading: true,
  isCartSaved: false,
};
